"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// CORE
const react_1 = __importStar(require("react"));
const react_router_1 = require("react-router");
const react_redux_1 = require("react-redux");
const am4core = __importStar(require("@amcharts/amcharts4/core"));
const animated_1 = __importDefault(require("@amcharts/amcharts4/themes/animated")); /* eslint-disable-line camelcase */
const query_string_1 = __importDefault(require("query-string"));
const luxon_1 = require("luxon");
const immutable_1 = require("immutable");
const styles_1 = require("@mui/material/styles");
const mui_1 = require("tss-react/mui");
const MultilineChart_1 = __importDefault(require("@mui/icons-material/MultilineChart"));
const PieChartOutlined_1 = __importDefault(require("@mui/icons-material/PieChartOutlined"));
const Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const ButtonGroup_1 = __importDefault(require("@mui/material/ButtonGroup"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const KeyboardArrowDown_1 = __importDefault(require("@mui/icons-material/KeyboardArrowDown"));
const KeyboardArrowUp_1 = __importDefault(require("@mui/icons-material/KeyboardArrowUp"));
// DATA
const core_1 = require("companion-app-components/utils/core");
const auth_1 = require("companion-app-components/flux/auth");
const reportsUtils_1 = require("companion-app-components/flux/reports/reportsUtils");
const chart_of_accounts_1 = require("companion-app-components/flux/chart-of-accounts");
const reportsSelectors_1 = require("companion-app-components/flux/reports/reportsSelectors");
const queryUtils_1 = require("utils/queryUtils");
const retrievers_1 = require("data/accounts/retrievers");
// COMPONENTS
const EmbeddedRegister_1 = __importDefault(require("components/EmbeddedRegister"));
const ZeroStateView_1 = __importDefault(require("components/ZeroStateView"));
const QAmountField_1 = __importDefault(require("components/QAmountField"));
const QButton_1 = __importDefault(require("components/QButton"));
const stacked_bar_inline_svg_1 = __importDefault(require("assets/reports/stacked-bar.inline.svg"));
const sideways_bar_inline_svg_1 = __importDefault(require("assets/reports/sideways-bar.inline.svg"));
const grouped_bar_inline_svg_1 = __importDefault(require("assets/reports/grouped-bar.inline.svg"));
const happy_star_svg_1 = __importDefault(require("assets/happy-star.svg"));
const ChartSettings_1 = __importDefault(require("containers/NewReports/components/ChartSettings"));
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const StdDialog_1 = __importDefault(require("components/Dialogs/StdDialog"));
const RendersCount_1 = __importDefault(require("components/RendersCount"));
const useQPreferences_1 = __importDefault(require("components/QPreferences/useQPreferences"));
const reportsSelectors = __importStar(require("data/reports/selectors"));
// LOCAL
const state_1 = require("../state");
const SidewaysBarChart_1 = __importDefault(require("./charts/SidewaysBarChart"));
const NetIncomeChart_1 = __importDefault(require("./charts/NetIncomeChart"));
const BarChart_1 = __importDefault(require("./charts/BarChart"));
const ReportsPieChart_1 = __importDefault(require("./charts/ReportsPieChart"));
const ReportsMenu_1 = __importDefault(require("./ReportsMenu"));
const utils_1 = require("../utils");
const styles_2 = __importDefault(require("../styles"));
const IncomeExpenseReportTable_1 = __importDefault(require("./IncomeExpenseReportTable"));
const VALID_GRAPHS = [utils_1.Tabs.SPENDING, utils_1.Tabs.NET_INCOME, utils_1.Tabs.INCOME_VS_SPENDING];
const useStyles = (0, mui_1.makeStyles)()(styles_2.default);
const getChartOptions = (tabName, isOverTime) => {
    if (tabName === utils_1.Tabs.SPENDING) {
        if (isOverTime) {
            return [utils_1.ChartTypes.GROUPED_BAR, utils_1.ChartTypes.STACKED_BAR];
        }
        return [utils_1.ChartTypes.PIE, utils_1.ChartTypes.SIDEWAYS_BAR];
    }
    if (tabName === utils_1.Tabs.NET_INCOME) {
        return [utils_1.ChartTypes.GROUPED_BAR];
    }
    if (tabName === utils_1.Tabs.INCOME_VS_SPENDING) {
        return [utils_1.ChartTypes.INCOME_VS_SPENDING];
    }
    return [];
};
// ensure the theme is being used
am4core.useTheme(animated_1.default);
am4core.options.autoDispose = true;
const GraphWithRegister = () => {
    var _a;
    const { state, dispatch } = (0, react_1.useContext)(state_1.ReportsStateContext);
    const { setDatasetPreference } = (0, useQPreferences_1.default)();
    const { dateRange, chartType, timeStep, filterObject, breadcrumbs, pageInitialized, fallbackSelect, breakdownIncomeVsExpense, visibleSectionIncomeVsExpense, hasAppliedFilters = undefined, hasClearedFilters = undefined, } = state;
    const graphRef = (0, react_1.useRef)(null);
    const selectedCellDetails = (0, react_1.useRef)(null);
    const latestAllTxnsRef = (0, react_1.useRef)(null);
    // extract route params
    const params = (0, react_router_1.useParams)();
    const tabName = (params === null || params === void 0 ? void 0 : params.tabName) || utils_1.Tabs.SPENDING;
    const groupBy = ((_a = params === null || params === void 0 ? void 0 : params.groupBy) === null || _a === void 0 ? void 0 : _a.replace('by-', '')) || (0, utils_1.getDefaultGroupByFromTabName)(tabName);
    const isOverTime = (params === null || params === void 0 ? void 0 : params.layoutView) ? (params === null || params === void 0 ? void 0 : params.layoutView) === 'over-time' : (0, utils_1.getDefaultIsOverTimeFromTabName)(tabName); // layoutView is string for isOverTime
    const showQuarterlyFilter = tabName === utils_1.Tabs.SPENDING
        && (dateRange.id === state_1.monthDateRanges[2].id || dateRange.id === state_1.monthDateRanges[3].id);
    const showHeader = tabName !== utils_1.Tabs.INCOME_VS_SPENDING;
    const queryParams = query_string_1.default.parse(window.location.search);
    const isTabIncomeVsExpense = tabName === utils_1.Tabs.INCOME_VS_SPENDING;
    const reportGroupBy = isTabIncomeVsExpense ? breakdownIncomeVsExpense.id : groupBy || null;
    const { classes } = useStyles();
    const theme = (0, styles_1.useTheme)();
    const navigate = (0, react_router_1.useNavigate)();
    const [registerTxns, setRegisterTxns] = (0, react_1.useState)(null);
    const [chartData, setChartData] = (0, react_1.useState)([]);
    const [orderedFields, setOrderedFields] = (0, react_1.useState)(['total']);
    const [uncategorizedTransactionsCount, setUncategorizedTransactionsCount] = (0, react_1.useState)(0);
    const [currency, setCurrency] = (0, react_1.useState)(null);
    const [showDownloadModal, setShowDownloadModal] = (0, react_1.useState)(false);
    const [showClearButton, setShowClearButton] = (0, react_1.useState)(false);
    const [showTxnActivities, setShowTxnActivities] = (0, react_1.useState)(true);
    const dataset = (0, react_redux_1.useSelector)(auth_1.authSelectors.getCurrentDataset);
    const subSelector = (0, react_1.useMemo)(() => {
        switch (tabName) {
            case utils_1.Tabs.SPENDING:
            case utils_1.Tabs.NET_INCOME:
                return reportsSelectors.getIncomeSpendingReportForDisplay;
            case utils_1.Tabs.INCOME_VS_SPENDING:
                return reportsSelectors.getNetIncomeReportForDisplay;
            default:
                return null;
        }
    }, [tabName]);
    const data = (0, react_redux_1.useSelector)((store) => (0, reportsSelectors_1.getReportForDisplay)(store, {
        reportName: tabName,
        dateRange: dateRange.value,
        filterObject,
        timeStep: timeStep === null || timeStep === void 0 ? void 0 : timeStep.toLowerCase(),
        isOverTime,
        chartType,
        groupBy: reportGroupBy,
        subSelector,
        pageInitialized,
    }));
    const coaNodesById = (0, react_redux_1.useSelector)((store) => chart_of_accounts_1.chartOfAccountsSelectors.getChartOfAccountNodesById(store));
    const scrollRowIntoView = (rowId) => {
        const tableRow = document.getElementById(rowId);
        if (tableRow) {
            tableRow.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center',
            });
        }
    };
    const clearSelectionState = (0, react_1.useCallback)(() => {
        dispatch({
            type: 'update',
            payload: {
                selectedGraphCategory: '',
                selectedReportTableCell: '',
                clearGraphSelection: true,
            },
        });
    }, [dispatch]);
    const restoreAllRegisterTxns = (0, react_1.useCallback)(() => {
        setRegisterTxns(latestAllTxnsRef.current);
    }, []);
    const handleReportTableCellSelect = (0, react_1.useCallback)((txns, rowId, durationCategory, groupKey, periodKey, section) => {
        fallbackSelect.current = null;
        setShowClearButton(true);
        const selectedCellKey = section ? `${section}-${rowId}-${durationCategory}` : `${rowId}-${durationCategory}`;
        dispatch({
            type: 'update',
            payload: { selectedReportTableCell: selectedCellKey, selectedGraphCategory: '', clearGraphSelection: true },
        });
        if (txns) {
            selectedCellDetails.current = {
                rowId,
                category: durationCategory,
                periodKey,
                groupKey,
                section,
            };
            setRegisterTxns(txns);
            return;
        }
        setRegisterTxns((data === null || data === void 0 ? void 0 : data.get('allTxns')) || null);
    }, [data, setRegisterTxns, dispatch, fallbackSelect]);
    const handleClearButtonClick = (event) => {
        event.stopPropagation();
        fallbackSelect.current = null;
        clearSelectionState();
        setShowClearButton(false);
        selectedCellDetails.current = null;
        restoreAllRegisterTxns();
    };
    const handleIsOverTimeSelect = (0, react_1.useCallback)((option) => {
        dispatch({ type: 'update', payload: { isOverTime: option.value === 'over-time' } });
        navigate(`/reports/${tabName}/by-${groupBy}/${option.value}`);
    }, [dispatch, navigate, tabName, groupBy]);
    const handleYearlyFilterSelect = (0, react_1.useCallback)((option) => {
        dispatch({ type: 'update', payload: { timeStep: option.value } });
    }, [dispatch]);
    const resetTransactionRegister = (0, react_1.useCallback)(() => {
        setShowClearButton(false);
        fallbackSelect.current = null;
        selectedCellDetails.current = null;
        clearSelectionState();
        restoreAllRegisterTxns();
    }, [fallbackSelect, clearSelectionState, restoreAllRegisterTxns]);
    (0, react_1.useEffect)(() => () => {
        selectedCellDetails.current = null;
        setShowClearButton(false);
        setShowTxnActivities(true);
        dispatch({
            type: 'update',
            payload: {
                selectedGraphCategory: '',
                selectedReportTableCell: '',
                visibleSectionIncomeVsExpense: '',
                clearGraphSelection: true,
                breakdownIncomeVsExpense: utils_1.IncomeVsExpenseBreakdownTypes[0],
            },
        });
    }, [tabName, dispatch]);
    (0, react_1.useEffect)(() => {
        latestAllTxnsRef.current = (data === null || data === void 0 ? void 0 : data.get('allTxns')) || null;
    }, [data]);
    const incomeData = (0, react_1.useMemo)(() => {
        const incomeDataMain = data === null || data === void 0 ? void 0 : data.get('incomes');
        if (!incomeDataMain) {
            return [];
        }
        return incomeDataMain.map((incomeRecord) => (Object.assign(Object.assign({}, incomeRecord), { periods: incomeRecord.periods.map((periodRecord, index) => {
                const date = luxon_1.DateTime.fromISO(periodRecord.timeStamp);
                return Object.assign(Object.assign({}, periodRecord), { txns: (0, immutable_1.List)(periodRecord.txns), category: (0, utils_1.getTimestepLabel)(timeStep, date, index === incomeRecord.periods.size - 1, dateRange.value.end) });
            }) })));
    }, [data, timeStep, dateRange.value.end]);
    const expenseData = (0, react_1.useMemo)(() => {
        const expenseDataMain = data === null || data === void 0 ? void 0 : data.get('expenses');
        if (!expenseDataMain) {
            return [];
        }
        return expenseDataMain.map((expenseRecord) => (Object.assign(Object.assign({}, expenseRecord), { periods: expenseRecord.periods.map((periodRecord, index) => {
                const date = luxon_1.DateTime.fromISO(periodRecord.timeStamp);
                return Object.assign(Object.assign({}, periodRecord), { txns: (0, immutable_1.List)(periodRecord.txns), category: (0, utils_1.getTimestepLabel)(timeStep, date, index === expenseRecord.periods.size - 1, dateRange.value.end) });
            }) })));
    }, [data, timeStep, dateRange.value.end]);
    const updatedRegisterTxns = (0, react_1.useCallback)(() => {
        if (selectedCellDetails.current !== null) {
            setRegisterTxns((0, utils_1.getSelectedIncomeExpenseReportCellTxns)(selectedCellDetails.current, incomeData, expenseData));
            return;
        }
        setRegisterTxns((data === null || data === void 0 ? void 0 : data.get('allTxns')) || null);
    }, [data, expenseData, incomeData]);
    (0, react_1.useEffect)(() => {
        if (tabName !== utils_1.Tabs.INCOME_VS_SPENDING) {
            return;
        }
        core_1.tracker.track(core_1.tracker.events.incomeExpenseReport, {
            breakdown: breakdownIncomeVsExpense.label,
            dateRange: dateRange.label,
            interval: timeStep.replace('s', 'ly'),
            hideGraph: (0, utils_1.getSectionValueForTracking)(breakdownIncomeVsExpense.id, visibleSectionIncomeVsExpense, utils_1.VISIBLE_SECTIONS.graph),
            hideReport: (0, utils_1.getSectionValueForTracking)(breakdownIncomeVsExpense.id, visibleSectionIncomeVsExpense, utils_1.VISIBLE_SECTIONS.report),
        });
    }, [breakdownIncomeVsExpense, visibleSectionIncomeVsExpense, timeStep, dateRange, tabName]);
    (0, react_1.useEffect)(() => {
        selectedCellDetails.current = null;
        setShowClearButton(false);
        clearSelectionState();
        restoreAllRegisterTxns();
    }, [dateRange, filterObject, breakdownIncomeVsExpense, timeStep, clearSelectionState, restoreAllRegisterTxns]);
    (0, react_1.useEffect)(() => {
        updatedRegisterTxns();
    }, [updatedRegisterTxns]);
    (0, react_1.useEffect)(() => {
        var _a, _b, _c, _d, _f, _g, _h;
        if (!data) {
            return;
        }
        const subgroupArray = ((_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.get('chartData')) === null || _a === void 0 ? void 0 : _a.totals) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.subgroups) || [];
        let transactionGroup = subgroupArray;
        if (subgroupArray.length > 9) {
            const everythingElseTransactions = subgroupArray.find((transaction) => (transaction === null || transaction === void 0 ? void 0 : transaction.groupKey) === 'Everything else');
            transactionGroup = everythingElseTransactions === null || everythingElseTransactions === void 0 ? void 0 : everythingElseTransactions.subgroups;
        }
        const uncategorizedTransactions = transactionGroup === null || transactionGroup === void 0 ? void 0 : transactionGroup.find((transaction) => (transaction === null || transaction === void 0 ? void 0 : transaction.groupKey) === 'Uncategorized');
        setUncategorizedTransactionsCount(((_d = uncategorizedTransactions === null || uncategorizedTransactions === void 0 ? void 0 : uncategorizedTransactions.txns) === null || _d === void 0 ? void 0 : _d.size) || 0);
        // @ts-expect-error ts(2345) - FIXME: Type 'undefined' is not assignable to type 'SetStateAction<null>'
        setCurrency((0, retrievers_1.getCurrencyString)((_g = (_f = data === null || data === void 0 ? void 0 : data.get('allTxns')) === null || _f === void 0 ? void 0 : _f.first()) === null || _g === void 0 ? void 0 : _g.accountId));
        const periods = (_h = data.get('chartData')) === null || _h === void 0 ? void 0 : _h.periods;
        if (isOverTime && periods && dateRange.value) {
            const rawChartData = data === null || data === void 0 ? void 0 : data.get('chartData');
            setOrderedFields((rawChartData === null || rawChartData === void 0 ? void 0 : rawChartData.orderedFields) || ['total']);
            setChartData(periods.map((per, index) => {
                const date = luxon_1.DateTime.fromISO(per.timeStamp);
                const totalAmt = per.total ? per.total : per.netIncomeTotal;
                let isLastIndex = false;
                let periodStartDate = date;
                let periodEndDate = timeStep !== 'quarters' ? periodStartDate.endOf('month') : periodStartDate.plus({ months: 2 }).endOf('month');
                if (index === 0) {
                    periodStartDate = dateRange.value.start;
                }
                if (index === periods.length - 1) {
                    isLastIndex = true;
                    periodEndDate = dateRange.value.end;
                }
                else if (isTabIncomeVsExpense && timeStep === 'years') {
                    periodEndDate = periodEndDate.endOf('year');
                }
                return (Object.assign(Object.assign(Object.assign({}, per), { totalValues: {
                        sign: totalAmt < 0 ? '-' : '',
                        value: totalAmt === undefined ? 0 : Math.abs(totalAmt),
                    }, txns: undefined, category: (isTabIncomeVsExpense && timeStep === 'none') ? dateRange.label : (0, utils_1.getTimestepLabel)(timeStep, date, isLastIndex, dateRange.value.end) }), (tabName !== utils_1.Tabs.SPENDING && { periodStartDate, periodEndDate })));
            }));
        }
        else if (!isOverTime && breadcrumbs.length === 0) {
            const firstCrumb = { name: `All ${(0, reportsUtils_1.makeGroupByPlural)(groupBy !== null && groupBy !== void 0 ? groupBy : '')}`, categoryId: undefined, total: null }; // null total cus we don't need to show it
            dispatch({ type: 'update', payload: { breadcrumbs: [firstCrumb] } });
        }
    }, [data, dispatch, groupBy, isOverTime, breadcrumbs, timeStep, dateRange, tabName, isTabIncomeVsExpense]);
    const handleDrillDown = (0, react_1.useCallback)((item) => {
        var _a, _b, _c;
        if (!item) { // bugsnag
            return;
        }
        const itemCrumb = { name: item.category, categoryId: item.categoryId, total: item.total };
        const [group] = (0, utils_1.findGroupByCategoryId)(item.categoryId, (_a = data === null || data === void 0 ? void 0 : data.get('chartData')) === null || _a === void 0 ? void 0 : _a.totals[0]);
        if (groupBy === 'category' && group) { // if it's grouped by categories then it could be just one L1 category
            const crumbIndex = breadcrumbs.findIndex((bc) => bc.name === item.category);
            const crumbItemCount = breadcrumbs.filter((x) => x.categoryId === item.categoryId).length;
            if (orderedFields.length !== 1 || // there is more than one ordered field
                // for this next line it's >1 because the parent cat should always be one of the subgroups
                ((((_c = (_b = group === null || group === void 0 ? void 0 : group.subgroups) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.groupKey) !== (group === null || group === void 0 ? void 0 : group.groupKey) || crumbItemCount === 0)
                    && (crumbIndex === -1 || crumbIndex !== breadcrumbs.length - 2))) { // or drilling into subgroups
                dispatch({ type: 'update', payload: { breadcrumbs: breadcrumbs.concat([itemCrumb]) } });
            }
            else if (orderedFields.length === 1 && breadcrumbs.length <= 1) { // only one item but it's not drilled into
                dispatch({ type: 'update', payload: { breadcrumbs: breadcrumbs.concat([itemCrumb]) } });
            }
        }
        else if (orderedFields.length !== 1) { // if it's not grouped by categories then we only want to drill if there's more than one ordered field
            dispatch({ type: 'update', payload: { breadcrumbs: breadcrumbs.concat([itemCrumb]) } });
        }
    }, [breadcrumbs, orderedFields, dispatch, data, groupBy]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (!data || isOverTime || !data.get('chartData').totals) {
            return;
        }
        let activeGroup = (_a = data.get('chartData')) === null || _a === void 0 ? void 0 : _a.totals[0];
        const newCrumbs = [{ name: `All ${(0, reportsUtils_1.makeGroupByPlural)(groupBy !== null && groupBy !== void 0 ? groupBy : '')}`, categoryId: undefined, total: null }];
        let totalsMatch = true;
        const crumbsMatch = breadcrumbs.length > 0 && // if there are no breadcrumbs then they automatically don't match
            newCrumbs[0].name === breadcrumbs[0].name && // essentially checks the groupBy hasn't changed
            breadcrumbs.slice(1).every((crumb) => {
                var _a, _b;
                let nextActiveGroup;
                if (crumb.categoryId) { // if it has a category id then use that to match
                    nextActiveGroup = (_a = activeGroup === null || activeGroup === void 0 ? void 0 : activeGroup.subgroups) === null || _a === void 0 ? void 0 : _a.find((g) => g.categoryId === crumb.categoryId);
                }
                else { // otherwise we match to groupKey, the name of the group essentially
                    nextActiveGroup = (_b = activeGroup === null || activeGroup === void 0 ? void 0 : activeGroup.subgroups) === null || _b === void 0 ? void 0 : _b.find((g) => (g === null || g === void 0 ? void 0 : g.groupKey) === crumb.name);
                }
                if (nextActiveGroup) {
                    if (crumb.total !== nextActiveGroup.total) {
                        totalsMatch = false;
                    }
                    newCrumbs.push(Object.assign(Object.assign({}, crumb), { total: nextActiveGroup.total }));
                    activeGroup = nextActiveGroup;
                    return true;
                }
                // if the data has changed and the breadcrumbs no longer point to existing groups
                return false;
            });
        if (!crumbsMatch || !totalsMatch) { // if there was an issue matching breadcrumbs to group
            dispatch({ type: 'update', payload: { breadcrumbs: newCrumbs } }); // update to the adjusted breadcrumbs
        }
        const newChartData = activeGroup.subgroups.length > 0
            ? activeGroup.subgroups.map((g) => ({ category: g === null || g === void 0 ? void 0 : g.groupKey, total: g.total, groupKey: g === null || g === void 0 ? void 0 : g.groupKey, categoryId: g.categoryId }))
            :
                [{ category: activeGroup === null || activeGroup === void 0 ? void 0 : activeGroup.groupKey, total: activeGroup.total, categoryId: activeGroup.categoryId }];
        setChartData(newChartData);
        const newOrderedFields = activeGroup.subgroups.length > 0
            ? activeGroup.subgroups.map((g) => g === null || g === void 0 ? void 0 : g.groupKey) : [activeGroup === null || activeGroup === void 0 ? void 0 : activeGroup.groupKey];
        setOrderedFields(newOrderedFields);
        setRegisterTxns(activeGroup.txns);
    }, [breadcrumbs, data, isOverTime, groupBy, dispatch]);
    const handleBarSelect = (0, react_1.useCallback)((category) => {
        var _a;
        fallbackSelect.current = category;
        if (category) {
            const periods = (_a = data === null || data === void 0 ? void 0 : data.get('chartData')) === null || _a === void 0 ? void 0 : _a.periods;
            const selectedBarIndex = periods === null || periods === void 0 ? void 0 : periods.findIndex((objPeriod, index) => {
                const date = luxon_1.DateTime.fromISO(objPeriod.timeStamp);
                const formatCategory = (0, utils_1.getTimestepLabel)(timeStep, date, index === periods.length - 1, dateRange.value.end);
                const foundMatch = formatCategory === category;
                if (foundMatch) {
                    dispatch({ type: 'update', payload: { selectedGraphCategory: category, selectedReportTableCell: '', clearGraphSelection: false } });
                    scrollRowIntoView(category);
                }
                return foundMatch;
            });
            if (selectedBarIndex !== undefined && selectedBarIndex > -1 && selectedBarIndex < periods.length) {
                const selectedBar = data === null || data === void 0 ? void 0 : data.get('chartData').periods[selectedBarIndex];
                selectedCellDetails.current = null;
                setRegisterTxns(selectedBar.txns);
                return;
            }
        }
        dispatch({ type: 'update', payload: { selectedGraphCategory: '', selectedReportTableCell: '' } });
        setRegisterTxns(data === null || data === void 0 ? void 0 : data.get('allTxns'));
    }, [data, setRegisterTxns, timeStep, fallbackSelect, dispatch, dateRange.value.end]);
    // temporary effect to handle selecting stuff coming from the dashboard
    (0, react_1.useEffect)(() => {
        var _a, _b, _c, _d, _f, _g, _h;
        if (!(data === null || data === void 0 ? void 0 : data.get('chartData')) || !pageInitialized) {
            return;
        }
        const monthIndex = Number(queryParams.selectMonth);
        if (queryParams.selectMonth || monthIndex === 0) {
            if (!Number.isNaN(monthIndex) && monthIndex < ((_b = (_a = data === null || data === void 0 ? void 0 : data.get('chartData')) === null || _a === void 0 ? void 0 : _a.periods) === null || _b === void 0 ? void 0 : _b.length)) { // if it it doesn't work for whatever reason we drop it
                const preselect = luxon_1.DateTime.fromISO((_c = data === null || data === void 0 ? void 0 : data.get('chartData')) === null || _c === void 0 ? void 0 : _c.periods[monthIndex].timeStamp).toFormat(timeStep === 'days' ? 'd' : 'LLL yy');
                fallbackSelect.current = preselect;
                (0, queryUtils_1.removeQuery)('selectMonth');
            }
        }
        if (queryParams.selectCategory && ((_d = data === null || data === void 0 ? void 0 : data.get('chartData')) === null || _d === void 0 ? void 0 : _d.totals)) {
            const categoryId = queryParams.selectCategory;
            const [group, crumbs] = (0, utils_1.findGroupByCategoryId)(categoryId, (_f = data === null || data === void 0 ? void 0 : data.get('chartData')) === null || _f === void 0 ? void 0 : _f.totals[0], [{ name: 'All categories', categoryId: undefined, total: null }]);
            if (group && crumbs) { // if we didn't find the group the crumbs don't matter
                dispatch({ type: 'update', payload: { breadcrumbs: crumbs } });
                (0, queryUtils_1.removeQuery)('selectCategory');
            }
        }
        if (queryParams.selectPayee && ((_g = data === null || data === void 0 ? void 0 : data.get('chartData')) === null || _g === void 0 ? void 0 : _g.totals)) {
            const payee = (_h = data === null || data === void 0 ? void 0 : data.get('chartData')) === null || _h === void 0 ? void 0 : _h.totals[0].subgroups[queryParams.selectPayee];
            const payeeCrumbs = [{ name: 'All payees', categoryId: undefined, total: null }];
            if (queryParams.selectPayee && payee) {
                const itemCrumb = { name: payee.groupKey, total: payee.total };
                payeeCrumbs.push(itemCrumb);
                dispatch({ type: 'update', payload: { breadcrumbs: payeeCrumbs } });
                (0, queryUtils_1.removeQuery)('selectPayee');
            }
        }
    }, [data, dispatch, queryParams, timeStep, pageInitialized, fallbackSelect]);
    const handleClearFilters = (0, react_1.useCallback)((e) => {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        setDatasetPreference({ reportsViewStates: { filterObject: null } });
        dispatch({ type: 'update', payload: { filterObject: null } });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);
    const chartToShow = (0, react_1.useMemo)(() => {
        var _a, _b;
        const hasFilters = filterObject !== null;
        if ((data === null || data === void 0 ? void 0 : data.get('allTxns').size) === 0 && (data === null || data === void 0 ? void 0 : data.get('total')) === 0) {
            return (<ZeroStateView_1.default primary=" " icon={happy_star_svg_1.default} secondary={<>
              <span>
                None yet for {((_a = dateRange === null || dateRange === void 0 ? void 0 : dateRange.label) === null || _a === void 0 ? void 0 : _a.startsWith('Last')) ? 'the ' : ''} {(_b = dateRange === null || dateRange === void 0 ? void 0 : dateRange.label) === null || _b === void 0 ? void 0 : _b.toLowerCase()}
              </span>
              <br />
              <span>
                Try
                {hasFilters ?
                        <>
                      <span role="presentation" onClick={handleClearFilters} className={hasFilters ? classes.clickableText : ''}>
                        &nbsp;clearing filters&nbsp;
                      </span>&quot;or choose &quot;
                    </>
                        :
                            ' choosing '}
                a different date range
              </span>
            </>}/>);
        }
        let adjustedOrderedFields = null;
        const showUncategorizedTransactionsLink = groupBy === 'category' && uncategorizedTransactionsCount > 0 && breadcrumbs.length < 2;
        switch (chartType) {
            case utils_1.ChartTypes.BAR:
            case utils_1.ChartTypes.GROUPED_BAR:
            case utils_1.ChartTypes.STACKED_BAR:
                return (<BarChart_1.default chartId={`reports-page-bar-chart${tabName}`} orderedFields={orderedFields} data={chartData} stacked={chartType === utils_1.ChartTypes.STACKED_BAR} onBarSelect={handleBarSelect} fallbackSelect={fallbackSelect} overrideColors={tabName === utils_1.Tabs.NET_INCOME || groupBy === 'none' ? [am4core.color(theme.palette.reports.positiveColor)] : null} withLegend={tabName !== utils_1.Tabs.NET_INCOME && groupBy !== 'none'} defaultColors={tabName === utils_1.Tabs.NET_INCOME || groupBy === 'none' ? [am4core.color(theme.palette.reports.positiveColor), am4core.color(theme.palette.reports.negativeColor)] : null} showScrollBar={dateRange.custom} noOfMonths={dateRange.noOfMonths || 0} adjustValueAxisScale={tabName === utils_1.Tabs.NET_INCOME} ref={graphRef} currency={currency}/>);
            case utils_1.ChartTypes.PIE:
                if (groupBy === 'tag') { // special for tags
                    let hasEverythingElse = false;
                    let hasUntagged = false;
                    adjustedOrderedFields = orderedFields.filter((field) => {
                        hasEverythingElse = field === 'Everything else' || hasEverythingElse;
                        hasUntagged = field === 'Untagged' || hasUntagged;
                        return field !== 'Everything else' && field !== 'Untagged';
                    });
                    if (hasEverythingElse)
                        adjustedOrderedFields.push('Everything else');
                    if (hasUntagged)
                        adjustedOrderedFields.push('Untagged');
                }
                return (<ReportsPieChart_1.default data={chartData} orderedFields={adjustedOrderedFields || orderedFields} onSliceClick={handleDrillDown} sliceExclusions={(orderedFields.length > 1) ? ['Untagged'] : null} uncategorizedTransactionsCount={uncategorizedTransactionsCount} showUncategorizedTransactionsLink={showUncategorizedTransactionsLink} ref={graphRef}/>);
            case utils_1.ChartTypes.SIDEWAYS_BAR:
                return (<SidewaysBarChart_1.default data={chartData} orderedFields={orderedFields} onBarClick={handleDrillDown} currency={currency} ref={graphRef}/>);
            case utils_1.ChartTypes.INCOME_VS_SPENDING:
                return (<NetIncomeChart_1.default data={chartData} onCategorySelect={handleBarSelect} fallbackSelect={fallbackSelect} showScrollBar={dateRange.custom} noOfMonths={dateRange.noOfMonths || 0} ref={graphRef} setShowClearButton={setShowClearButton} resetTransactionRegister={resetTransactionRegister}/>);
            default:
                return null;
        }
    }, [
        tabName,
        chartData,
        orderedFields,
        groupBy,
        chartType,
        theme,
        handleDrillDown,
        handleBarSelect,
        data,
        handleClearFilters,
        filterObject,
        fallbackSelect,
        dateRange,
        classes.clickableText,
        breadcrumbs,
        uncategorizedTransactionsCount,
        currency,
        resetTransactionRegister,
    ]);
    const handleChangeChartType = (0, react_1.useCallback)((newType) => (_e) => {
        dispatch({ type: 'update', payload: { chartType: newType } });
    }, [dispatch]);
    const chartButtons = (0, react_1.useMemo)(() => getChartOptions(tabName, isOverTime).map((op) => {
        let icon;
        let buttonStyle = {};
        const disableLeftRadius = { borderTopLeftRadius: '0px', borderBottomLeftRadius: '0px' };
        const disableRightRadius = { borderTopRightRadius: '0px', borderBottomRightRadius: '0px' };
        switch (op) {
            case utils_1.ChartTypes.BAR:
            case utils_1.ChartTypes.STACKED_BAR:
                icon = <stacked_bar_inline_svg_1.default className={classes.graphIconsWithOpacity}/>;
                buttonStyle = disableLeftRadius;
                break;
            case utils_1.ChartTypes.INCOME_VS_SPENDING:
            case utils_1.ChartTypes.GROUPED_BAR:
                icon = <grouped_bar_inline_svg_1.default className={classes.graphIconsWithOpacity}/>;
                buttonStyle = disableRightRadius;
                break;
            case utils_1.ChartTypes.SIDEWAYS_BAR:
                icon = <sideways_bar_inline_svg_1.default className={classes.graphIcons}/>;
                buttonStyle = disableLeftRadius;
                break;
            case utils_1.ChartTypes.MULTILINE:
                icon = <MultilineChart_1.default />;
                break;
            case utils_1.ChartTypes.PIE:
                icon = <PieChartOutlined_1.default />;
                buttonStyle = disableRightRadius;
                break;
            default:
                icon = <grouped_bar_inline_svg_1.default className={classes.graphIcons}/>;
        }
        return (<QTip_1.default key={`chart-type-button-${op}`} title={(0, utils_1.getChartIconTipLabel)(op)} placement="top" distance={0} enterDelay={500}>
        <QButton_1.default onClick={handleChangeChartType(op)} variant={'outlinedBasic'} style={Object.assign({ background: op === chartType ? theme.palette.border.main : 'transparent' }, (tabName === utils_1.Tabs.SPENDING ? buttonStyle : {}))}>
          {icon}
        </QButton_1.default>
      </QTip_1.default>);
    }), [tabName, isOverTime, chartType, handleChangeChartType, theme.palette.border.main, classes.graphIcons, classes.graphIconsWithOpacity]);
    const totalHeader = (0, react_1.useMemo)(() => ({
        [utils_1.Tabs.SPENDING]: 'Total expenses',
        [utils_1.Tabs.NET_INCOME]: 'Total net income',
    })[tabName], [tabName]);
    const totalSign = [utils_1.Tabs.SPENDING].includes(tabName) ? -1 : 1;
    const chartContainerStyle = (0, react_1.useMemo)(() => [utils_1.ChartTypes.PIE, utils_1.ChartTypes.SIDEWAYS_BAR].includes(chartType) ? { padding: '0px 25px', maxWidth: '75%' } : {}, [chartType]);
    const dateHeader = (0, react_1.useMemo)(() => (<Typography_1.default>
      <span id="date_range_label">
        {tabName === 'net-worth' ? 'Current' : dateRange.value.toFormat('MMM dd, yyyy')}
      </span>
    </Typography_1.default>), [tabName, dateRange]);
    if (!VALID_GRAPHS.includes(tabName)) {
        return <div>Invalid Graph</div>;
    }
    const hideDownloadModal = () => {
        setShowDownloadModal(false);
    };
    const handleDownloadFile = (type) => {
        setShowDownloadModal(true);
        core_1.tracker.track(`${tabName}_${type}`, {
            type: groupBy,
        });
        (0, utils_1.generateDownloadFile)({
            data,
            chartType,
            graphRef,
            coaNodesById,
            currency,
            dateRange,
            tabName,
            groupBy,
            filter: filterObject,
            dataset,
            cb: hideDownloadModal,
            chartData,
            incomeData,
            expenseData,
            breakdownIncomeVsExpense,
            timeStep,
            includeReport: state.visibleSectionIncomeVsExpense !== utils_1.VISIBLE_SECTIONS.report,
            includeGraph: state.visibleSectionIncomeVsExpense !== utils_1.VISIBLE_SECTIONS.graph,
        })[type]();
    };
    const toggleTxnDisplay = () => {
        setShowTxnActivities((prev) => !prev);
    };
    return (<>
      <RendersCount_1.default id="newReportGraphWithRegister"/>
      <div className={classes.root}>
        <Paper_1.default elevation={0} className={classes.selectContainer}>
          <ChartSettings_1.default showDownloadButton handleDownload={handleDownloadFile} resetTransactionRegister={resetTransactionRegister}/>
          <div className={classes.headerContainer} id="graph-header-container">
            <div className={classes.flexColumn}>
              {showHeader &&
            <>
                  <Typography_1.default variant="body1" id="total-header-container">{totalHeader}</Typography_1.default>
                  <QAmountField_1.default expectedSign="positive" id="total_amount_label" styleProps={{ fontSize: 26 }} value={totalSign * Number(data === null || data === void 0 ? void 0 : data.get('total'))}/>
                  {dateHeader}
                </>}
            </div>
            <div className={classes.moreSettings} id="graph-settings-container">
              {tabName === utils_1.Tabs.SPENDING && <ButtonGroup_1.default>{chartButtons}</ButtonGroup_1.default>}
              <div className={classes.moreSettingsSpacer}/>
              {isOverTime && showQuarterlyFilter && <ReportsMenu_1.default id={'quarterly_dropdown_button'} disabled={tabName === utils_1.Tabs.INCOME_VS_SPENDING || tabName === utils_1.Tabs.NET_INCOME || breadcrumbs.length > 1} initialValue={timeStep === 'quarters' ? utils_1.IntervalFilterOptions[1] : utils_1.IntervalFilterOptions[0]} options={utils_1.IntervalFilterOptions} onSelect={handleYearlyFilterSelect} disableShadow/>}
              {isOverTime && showQuarterlyFilter && <div className={classes.moreSettingsSpacer}/>}
              {tabName === utils_1.Tabs.SPENDING && (<ReportsMenu_1.default id={'total_dropdown_button'} disabled={tabName === utils_1.Tabs.INCOME_VS_SPENDING || tabName === utils_1.Tabs.NET_INCOME || breadcrumbs.length > 1} initialValue={isOverTime ? utils_1.isOverTimeOptions[1] : utils_1.isOverTimeOptions[0]} options={utils_1.isOverTimeOptions} onSelect={handleIsOverTimeSelect} disableShadow/>)}
            </div>
          </div>
          {(!visibleSectionIncomeVsExpense || visibleSectionIncomeVsExpense === utils_1.VISIBLE_SECTIONS.report) && (<div style={chartContainerStyle} className={classes.chartContainer} id="chart-container">
              {[utils_1.ChartTypes.GROUPED_BAR, utils_1.ChartTypes.INCOME_VS_SPENDING].includes(chartType)
                && (hasAppliedFilters || hasClearedFilters)
                && <div className={classes.filterOverlay}/>}
              {chartToShow}
            </div>)}
          {tabName === utils_1.Tabs.INCOME_VS_SPENDING
            && (!visibleSectionIncomeVsExpense || visibleSectionIncomeVsExpense === utils_1.VISIBLE_SECTIONS.graph)
            && breakdownIncomeVsExpense.id !== utils_1.IncomeVsExpenseBreakdownTypes[0].id
            && (data === null || data === void 0 ? void 0 : data.get('allTxns').size) !== 0
            && (<IncomeExpenseReportTable_1.default chartData={chartData} expenseData={expenseData} incomeData={incomeData} handleReportTableCellSelect={handleReportTableCellSelect} handleClearButtonClick={handleClearButtonClick} interval={timeStep} breakdownType={breakdownIncomeVsExpense.id}/>)}
        </Paper_1.default>
      </div>
      <div>
        <Typography_1.default variant="h6" mb={2}>
          Transaction Activity
          <IconButton_1.default aria-label={showTxnActivities ? 'Hide transaction activity' : 'Show transaction activity'} onClick={toggleTxnDisplay} size="small">
            {showTxnActivities ? <KeyboardArrowDown_1.default /> : <KeyboardArrowUp_1.default />}
          </IconButton_1.default>
        </Typography_1.default>
        {showTxnActivities &&
            <>
            {showClearButton && (<Tooltip_1.default arrow placement="right" componentsProps={{
                        tooltip: {
                            sx: { maxWidth: 'none' },
                        },
                    }} title="This clears the selection from graph or report table above.">
                <Button_1.default variant="contained" sx={{ mb: 2 }} onClick={handleClearButtonClick}>
                  Clear
                </Button_1.default>
              </Tooltip_1.default>)}
            <div className={classes.registerContainer}>
              {registerTxns && <EmbeddedRegister_1.default name="reportsRegister" overrideTxns={registerTxns} 
                // @ts-expect-error: showControls/hideDividers/hideSearch/noNew not in EmbeddedRegisterProps
                showControls hideDividers hideSearch noNew registerComfort="comfortable" elevation={1} zeroStateMessage="No transactions"/>}
            </div>
          </>}
      </div>
      <div className={classes.bottomSpacer}>&nbsp;</div>
      <StdDialog_1.default open={showDownloadModal} showCloseButton={false}>
        <Typography_1.default sx={{ m: 2 }}>
          Preparing to download your report. Please wait...
        </Typography_1.default>
      </StdDialog_1.default>
    </>);
};
exports.default = GraphWithRegister;
